<div class="flex flex-justify-between flex-middle p1"
     [ngClass]="variant === 'modal' ? 'w-10' : 'w-2 w-3-m w-8-s'">
    <button class="product-reviews-prev fs-2 m-l-2-x m-l-2-l"
            type="button"
            aria-label="Previous page"
            (click)="prev()"
            [class.disabled]="page <= 1">
        <i class="icon-chevron-left"
           aria-hidden="true"></i>
    </button>

    <!-- nav -->
    <span class="p1 m-l-1 m-r-1">Page {{page}} of {{pagesCount}}</span>

    <!-- next page -->
    <button type="button"
            aria-label="Next page"
            class="product-reviews-next fs-2 m-r-2-x m-r-2-l"
            (click)="next()"
            [class.disabled]="page >= pagesCount">
        <i class="icon-chevron-right"
           aria-hidden="true"></i>
    </button>
</div>
